import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Header.module.scss";
import RusIcon from "../../assets/icons/flags/RusIcon";
import GerIcon from "../../assets/icons/flags/GerIcon";
import EngIcon from "../../assets/icons/flags/EngIcon";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    setIsDropdownOpen(false);
  };

  const getIcon = () => {
    switch (language) {
      case "ru":
        return <RusIcon />;
      case "de":
        return <GerIcon />;
      default:
        return <EngIcon />;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={styles.languageContainer}
      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
    >
      <span className={styles.languageIcon}>{getIcon()}</span>

      {isDropdownOpen && (
        <div className={styles.languageDropdown} ref={dropdownRef}>
          <button onClick={() => handleChangeLanguage("en")}>
            <EngIcon />
          </button>
          <button onClick={() => handleChangeLanguage("ru")}>
            <RusIcon />
          </button>
          <button onClick={() => handleChangeLanguage("de")}>
            <GerIcon />
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
